import { useOutletContext } from "react-router-dom";

/**
 * The client system this cabinet is showing.
 *
 * A cabinet account almost always holds exactly one grant. If it holds
 * several (a ministry running two systems), the first is used -- a switcher is
 * worth building only once somebody actually needs it.
 *
 * This is for LABELLING and for deciding whether to draw edit controls. It is
 * never trusted as a filter: the API scopes every query to the caller's grants
 * on the server, so a tampered value here changes nothing.
 */
export const useClient = () => {
  const { user } = useOutletContext();
  const grant = user?.memberships?.[0] ?? null;
  return {
    user,
    grant,
    clientId: grant?.client_id ?? "",
    clientName: grant?.client_name ?? "",
    // "read" grants look at everything and change nothing; the server refuses
    // their writes anyway, so hiding the controls is courtesy, not security.
    canManage: grant?.access === "admin",
  };
};
